import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'raHms'
})
export class RaHmsPipe implements PipeTransform {
  transform(value: number): unknown {
    const hourAngle = (value % 360.0) / 15.0;
    const hours = Math.floor(hourAngle);
    const minutes = Math.floor((hourAngle - hours) * 60);

    let seconds = ((hourAngle - hours) * 60 - minutes) * 60;
    seconds = Math.floor(seconds * 1000.0 + 0.5) / 1000.0;

    if (Math.abs(seconds) < 0.0009) {
      seconds = 0.0;
    }

    const hoursFormatted = paddingZeros(hours);
    const minutesFormatted = paddingZeros(minutes);
    const secondsFormatted = paddingZeros(seconds.toFixed(3));

    return `${hoursFormatted}:${minutesFormatted}:${secondsFormatted}`;
  }
}

@Pipe({
  name: 'decDms'
})
export class DecDmsPipe implements PipeTransform {
  transform(value: number): unknown {
    let sign = '+';

    if (value < 0.0) {
      sign = '-';
    }

    value = Math.abs(value);

    const degrees = Math.floor(value);
    let minutes = Math.floor((value - degrees) * 60);
    let seconds = ((value - degrees) * 60. - minutes) * 60.0;
    seconds = Math.floor(seconds * 1000 + 0.5) / 1000;

    if (seconds >= 60.0) {
      minutes++;
      seconds -= 60.0;
    }
    if (seconds < 0.0) {
      minutes--;
      seconds += 60.0;
    }
    if (Math.abs(seconds) < 0.001) {
      seconds = 0.0;
    }

    const degreesFormatted = paddingZeros(degrees);
    const minutesFormatted = paddingZeros(minutes);
    const secondsFormatted = paddingZeros(seconds.toFixed(3));

    return `${sign}${degreesFormatted}:${minutesFormatted}:${secondsFormatted}`;

  }
}

const paddingZeros = (value: any): string => {
  if (value < 10) {
    return '0' + value;
  }
  return value.toString();
};
